import styled from '@emotion/styled';
import { ImageFitType } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/common/LazyLoadingImageRaw.type';
import { withConfig } from 'src/withConfig';

interface ImagePropsType {
    allowShow: boolean;
    imgFit?: ImageFitType;
    isPlaceholder?: boolean;
}

export const Image = styled('img', { label: 'Image' })<ImagePropsType>`
    ${({ imgFit }): string => (imgFit === undefined ? '' : `object-fit: ${imgFit}`)};
    display: block;
    height: 100%;
    opacity: ${({ allowShow }): string => (allowShow ? '1' : '0')};
    transition: opacity 0.2s ease-in-out;
    width: 100%;
`;

interface ImageWrapperPropsType {
    isLoaded: boolean;
}

export const ImageWrapper = withConfig(theme => styled('div', { label: 'ImageWrapper' })<ImageWrapperPropsType>`
    position: absolute;
    &::before {
        background: ${theme.star.skeletonLoader.placeholder.bgColorDenary};
        content: '';
        inset: 0;
        opacity: ${({ isLoaded }): string => (isLoaded ? '0' : '1')};
        position: absolute;
        transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
        visibility: ${({ isLoaded }): string => (isLoaded ? 'hidden' : 'visible')};
    }
`);
